/**
 * @file GDotLookupButtonContainer.jsx
 * @description packs some action into the gDotObj Lookup button
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Oct 03, 2025 20:43
 */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { objectHas, objectExists, stringExists } from 'src/@common/utilities';

import GDotLookupButtonField from 'src/components/fieldComponents/GDotLookupButton/GDotLookupButtonField.jsx';

function GDotLookupButtonContainer(props) {
    const {
        sxStyle,
        gDotObj,
        cDot,
        transcript,
        handleGDotLookup,
    } = props;

    const [isDisabled, setIsDisabled] = useState(false);
    const [helpMsg, setHelpMsg] = useState('');

    useEffect(() => {

        if (objectExists(gDotObj) &&
            objectHas(gDotObj, 'hg38.gDot') &&
            stringExists(gDotObj.hg38.gDot)) {
            setHelpMsg('HG38 G-Dot exists');
            setIsDisabled(true);

        } else if (!stringExists(cDot)) {
            setHelpMsg('Missing C-Dot');
            setIsDisabled(true);

        } else if (!stringExists(transcript)) {
            setHelpMsg('Missing Transcript');
            setIsDisabled(true);

        } else {
            setHelpMsg('');
            setIsDisabled(false);
        }

    }, [gDotObj, cDot, transcript]);

    return <GDotLookupButtonField
        sxStyle={sxStyle}
        isDisabled={isDisabled}
        helpMsg={helpMsg}
        handleGDotLookup={handleGDotLookup}
    />
}

GDotLookupButtonContainer.propTypes = {
    sxStyle: PropTypes.object,
    gDotObj: PropTypes.object,
    handleGDotLookup: PropTypes.func.isRequired,
};

export default GDotLookupButtonContainer;